import { checklistPersonStatus } from './constants';

export const transhipmentSteps = {
  finalizePersonalData: {
    category: checklistPersonStatus.FINALIZE_PERSONAL_DATA,
    description: 'Dados pessoais',
    status: 'WAITING',
  },
  identityDocument: {
    category: checklistPersonStatus.IDENTITY,
    description: 'Documento de identificação',
    status: 'WAITING',
  },
  retakeSelfie: {
    category: checklistPersonStatus.RETAKE_SELFIE,
    status: 'WAITING',
  },
  selfie: {
    category: checklistPersonStatus.SELFIE,
    description: 'Foto do rosto (selfie)',
    status: 'WAITING',
  },
  accountPassword: {
    category: checklistPersonStatus.ACCOUNT_PASSWORD,
    description: 'Senha de acesso',
    status: 'WAITING',
  },
  validation: {
    category: checklistPersonStatus.VALIDATION,
    status: 'WAITING',
  },
  done: {
    category: checklistPersonStatus.DONE,
    status: 'WAITING',
  },
};
